import classes from "./DeleteModal.module.css";
import ModalWrapper from "../modalWrapper/ModalWrapper";
import { onDelete } from "../../redux/globalFunctions/globalFnSlice";
import { ActionBtn } from "../buttons/actionBtn/ActionBtn";
import { useLocation } from "react-router-dom";
import { deleteDriver } from "../../redux/driver/thunks/deleteDriverThunk";
import { cancelPackage } from "../../redux/package/thunks/cancelPackageThunk";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { useStatusEffect } from "../../helperFunctions/customHooks/useStatusEffect";
import { getScheduledDeliveries } from "../../redux/package/scheduledPackages/getScheduledDeliveries";
import { resetDriverDeleteStatus } from "../../redux/driver/slices/deleteDriverSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetCancelPackageStatus } from "../../redux/package/slices/cancelPackageSlice";
import {
  deleteScheduledDelivery,
  resetDeleteScheduledDeliveryState,
} from "../../redux/package/scheduledPackages/deleteScheduledDelivery";

export function DeleteModal() {
  const { isWithHistory, selectedDataForEdit } = useSelector(
    (state) => state.global
  );
  const cancelDeliveryState = useSelector((state) => state.cancelDelivery);
  const deleteDriverState = useSelector((state) => state.deleteDriver);
  const deleteScheduledDeliveryState = useSelector(
    (state) => state.scheduledDeliveries.deleteScheduledDelivery
  );

  const dispatch = useDispatch();
  const { t } = useTranslations();
  const modalText = t.deleteModal;
  const location = useLocation();

  const handleButtonClick = () => {
    if (!isWithHistory && location.pathname !== "/scheduled-deliveries") {
      dispatch(cancelPackage({ package_id: selectedDataForEdit.package_id }));
    } else if (location.pathname === "/scheduled-deliveries") {
      dispatch(deleteScheduledDelivery({ ds_id: selectedDataForEdit.ds_id }));
    } else {
      dispatch(deleteDriver({ u_id: selectedDataForEdit.u_id }));
    }
  };

  useStatusEffect({
    status: deleteScheduledDeliveryState.status,
    onError: onDelete,
    onSuccess: onDelete,
    successMessage: modalText.successDeleted,
    errorMessage: deleteScheduledDeliveryState.error,
    reFetch: getScheduledDeliveries,
    resetStatus: resetDeleteScheduledDeliveryState,
  });

  useStatusEffect({
    status: cancelDeliveryState.status,
    onError: onDelete,
    onSuccess: onDelete,
    successMessage: cancelDeliveryState?.package?.msg,
    errorMessage: cancelDeliveryState.error,
    resetStatus: resetCancelPackageStatus,
  });

  useStatusEffect({
    status: deleteDriverState.status,
    onError: onDelete,
    onSuccess: onDelete,
    successMessage: deleteDriverState?.message,
    errorMessage: deleteDriverState.error,
    resetStatus: resetDriverDeleteStatus,
  });

  const isStatusLoading =
    cancelDeliveryState.status === "loading" ||
    deleteDriverState.status === "loading" ||
    deleteScheduledDeliveryState.status === "loading";

  const headerText = isWithHistory
    ? modalText.deleteDriver.headerText
    : modalText.cancelDelivery.headerText;

  const confirmationText = isWithHistory
    ? modalText.deleteConfirmationText + " "
    : modalText.cancelDelivery.cancelConfirmationText + " ";

  const warningText = isWithHistory
    ? modalText.deleteDriver.warningText
    : modalText.cancelDelivery.warningText;

  return (
    <ModalWrapper
      onClick={() => dispatch(onDelete())}
      title={headerText}
      onSubmit={handleButtonClick}
    >
      <div>
        {confirmationText}
        <span className={classes.idSpan}>
          {isWithHistory
            ? selectedDataForEdit.u_firstname +
              " " +
              selectedDataForEdit.u_lastname
            : selectedDataForEdit.package_id || selectedDataForEdit.ds_id}
          ?
        </span>
      </div>
      <p>{warningText}</p>
      <div className={classes.buttons}>
        <ActionBtn
          btnType="cancel"
          text={modalText.cancel}
          onClick={() => dispatch(onDelete())}
        />
        <ActionBtn
          width={"100%"}
          height={"42px"}
          disabled={isStatusLoading}
          onClick={handleButtonClick}
          text={isStatusLoading ? <LoadingSpinner /> : modalText.confirm}
        />
      </div>
    </ModalWrapper>
  );
}
